import { z } from 'zod';

export const FlowStateSchema = z.record(z.string(), z.unknown());
export type FlowState = z.infer<typeof FlowStateSchema>;

export const TemplateContextSchema = z.object({
  input: z.record(z.string(), z.unknown()).optional(),
  trigger: z.record(z.string(), z.unknown()).optional(),
  state: z.record(z.string(), z.unknown()).optional(),
  nodes: z
    .record(
      z.string(),
      z.object({
        output: z.record(z.string(), z.unknown()).optional(),
        approvalResponse: z
          .object({
            approved: z.boolean().optional(),
            decision: z.string().optional(),
            feedback: z.string().optional(),
          })
          .optional(),
      }),
    )
    .optional(),
  iteration: z.number().int().optional(),
  memory: z
    .object({
      relevant: z.string().optional(),
    })
    .optional(),
  run: z
    .object({
      id: z.string(),
      url: z.string().optional(),
    })
    .optional(),
});
export type TemplateContext = z.infer<typeof TemplateContextSchema>;
